import { render } from "./UnderwritingCheck.vue?vue&type=template&id=784ba51a&lang=true"
import script from "./UnderwritingCheck.vue?vue&type=script&lang=js"
export * from "./UnderwritingCheck.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__